import React from 'react';
import { EnergyFlowDemo } from './EnergyFlowDemo';
import { images } from '../../data/images';
const features = [{
  title: 'Slim laden op dynamische prijzen',
  text: 'Laadt ’s nachts bij als stroom goedkoop is en levert terug als de prijs piekt.'
}, {
  title: 'Weersverwachting ingebouwd',
  text: 'Verwacht de app morgen weinig zon? Dan houdt hij vandaag extra reserve aan.'
}, {
  title: 'Noodstroom bij storing',
  text: 'Koelkast, wifi en verlichting blijven werken als het net uitvalt.'
}];
export function AppSection() {
  return <section id="app" className="scroll-mt-20 mx-auto max-w-[1440px] px-4 py-24 sm:px-6 lg:px-10 lg:py-32" data-id="element-30" data-mp="3f381plzzzya7">
      <div className="flex flex-col justify-between gap-6 lg:flex-row lg:items-end" data-id="element-31" data-mp="3t2pvkfs5i1qf">
        <h2 className="max-w-3xl text-4xl font-semibold leading-[1.04] tracking-tightest text-ink sm:text-5xl lg:text-[56px]" data-id="element-32" data-mp="3o0qr12kocyrw">
          Je hele energiehuishouding,
          <br className="hidden sm:block" data-id="element-33" data-mp="13cvxw632h94c" /> <span className="text-ink-muted" data-id="element-34" data-mp="13bksk1tz3tb4">live in beeld.</span>
        </h2>
        <p className="max-w-sm text-lg leading-relaxed text-ink-soft" data-id="element-35" data-mp="3187o78ds9lt5">
          Speel een dag af en zie hoe de batterij zonnestroom opvangt, ’s avonds je huis voedt en slim handelt op het net.
        </p>
      </div>
      <div className="mt-14 grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16" data-id="element-36" data-mp="3b7yj3b69a2tr">
        <div className="flex flex-col" data-id="element-37" data-mp="3g5gtl5zx8q3v">
          <ul className="divide-y divide-line border-y border-line" data-id="element-38" data-mp="3g4fgyx39bvk1">
            {features.map(f => <li key={f.title} className="py-5" data-id="element-39" data-mp="2igwy2tfvtd2b">
                <h3 className="text-[17px] font-medium text-ink" data-id="element-40" data-mp="2niw285jg4e0b">{f.title}</h3>
                <p className="mt-1 text-[15px] leading-relaxed text-ink-muted" data-id="element-41" data-mp="2sge1f47nvev4">{f.text}</p>
              </li>)}
          </ul>
          <img src={images.batteryRoom} alt="Stroomkluis thuisbatterij aan de muur in een bijkeuken" className="mt-10 hidden min-h-[240px] w-full flex-1 rounded-3xl object-cover lg:block" data-id="element-42" data-mp="2x978hyqlqzad" />
        </div>
        <div data-id="element-43" data-mp="1wqdr073mcazc">
          <EnergyFlowDemo data-id="element-44" data-mp="1wq5h8o2sllsd" />
        </div>
      </div>
    </section>;
}